import { BasicResponse } from '@/api/common/common.types.ts';
import {
  AdminChangePassword,
  ChangePassword,
  SalesPersonCandidate,
  UpdateUserAccessRequest,
  UserDetail,
} from '@/api/user/user.types.ts';
import { AxiosInstance } from 'axios';

export const createUserApi = (api: AxiosInstance) => ({
  changePassword: (changePassword: ChangePassword) =>
    api.post<BasicResponse>('/v1/users/change-password', changePassword),
  adminChangePassword: (changePassword: AdminChangePassword) =>
    api.post<BasicResponse>('/v1/users/admin-change-password', changePassword),
  getAllUsers: () => api.get<UserDetail[]>('/v1/users'),
  getUser: (userId: string) => api.get<UserDetail>(`/v1/users/${userId}`),
  updateUserAccess: (userId: string, body: UpdateUserAccessRequest) =>
    api.put<UserDetail>(`/v1/users/${userId}/access`, body),
  getSalesPersonCandidates: () =>
    api.get<SalesPersonCandidate[]>('/v1/users/sales-person-candidates'),
});
